import styles from "./PermBooleanMap.module.css";
import PermToggle from "./PermToggle";

export default function PermBooleanMap({ label, value, labels = {}, onChange }) {
    const obj = value && typeof value === "object" && !Array.isArray(value) ? value : {};

    const keys = Object.keys(obj);

    return (
        <div className={styles.box}>
            <div className={styles.header}>
                <div className={styles.label}>{label}</div>
                <div className={styles.count}>{keys.filter(k => obj[k]).length}/{keys.length}</div>
            </div>

            <div className={styles.list}>
                {keys.map((k) => (
                    <PermToggle
                        key={k}
                        label={labels[k] || k}
                        checked={!!obj[k]}
                        onChange={(checked) => {
                            onChange({
                                ...obj,
                                [k]: !!checked,
                            });
                        }}
                    />
                ))}
            </div>
        </div>
    );
}